module.exports = __webpack_public_path__ + "static/img/banner.03ca41d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invite/banner.png
// module id = DsFu
// module chunks = 0